import React from 'react';

interface Props {
  title: string;
  children: React.ReactNode;
  headingLevel?: 2 | 3;
}

const AdditionalResourcesBox = ({ title, children, headingLevel }: Props) => {
  const HeadingTag = `h${headingLevel}` as 'h2' | 'h3';
  return (
    <div className="wap__additional-resources-box">
      <HeadingTag className="wap__additional-resources-box-title h3">{title}</HeadingTag>
      {children}
    </div>
  );
};

AdditionalResourcesBox.defaultProps = {
  headingLevel: 2,
};

export default AdditionalResourcesBox;
